import React, { useEffect, useState } from 'react';

export function LiveClock({ className = '' }) {
  const [time, setTime] = useState(new Date());
  useEffect(() => {
    const id = setInterval(() => setTime(new Date()), 1000);
    return () => clearInterval(id);
  }, []);
  const t = time.toLocaleTimeString('en-US', { hour12: true });
  return <span className={className}>{t.replace(/\s/g, ' ')}</span>;
}

export function StatusIndicator({ className = '', label = 'all systems operational' }) {
  return (
    <div className={`flex items-center gap-2 text-[11px] uppercase tracking-wide ${className}`}>
      <span className="relative inline-flex">
        <span className="w-2 h-2 rounded-full bg-emerald-500" />
        <span className="absolute inset-0 rounded-full bg-emerald-500 animate-ping opacity-60" />
      </span>
      <span className="text-inkwell-500">{label}</span>
    </div>
  );
}
